module.exports = __webpack_public_path__ + "media/images/map/bus-689b28e94f9b0c69563e7daa0e408f14.svg";